import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openMenuMobile, setHeaderHeight, setHeaderWidth } from "../../redux";
import { LangContext } from "../../context/LangContext";
import useViewport from "../../hooks/useViewport";
import "./style.css"

function Header() {
    const dispatch = useDispatch();
    const headerRef = useRef(null);

    const { isMobile } = useViewport();
    const { language } = useContext(LangContext);

    const [isVisible, setIsVisible] = useState(true);

    const scrollPositionRef = useRef(0);
    const scrollReferenceRef = useRef(0);

    const menuIsOpen = useSelector(state => state.options.menuIsOpen);
    const headerHeight = useSelector(state => state.options.headerHeight);

    useEffect(() => {
        if (!headerRef.current) return;

        const updateHeaderDimension = () => {
            const height = headerRef.current.offsetHeight;
            dispatch(setHeaderHeight(height));

            const width = headerRef.current.offsetWidth;
            dispatch(setHeaderWidth(width));
        };

        updateHeaderDimension();
        window.addEventListener('resize', updateHeaderDimension);

        const resizeObserver = new ResizeObserver(updateHeaderDimension);
        resizeObserver.observe(headerRef.current);

        return () => {
            window.removeEventListener('resize', updateHeaderDimension);
            resizeObserver.disconnect();
        };
    }, [dispatch]);

    useEffect(() => {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const currentPosition = window.scrollY;

                    if (currentPosition < scrollPositionRef.current) {
                        setIsVisible(true);
                        scrollReferenceRef.current = currentPosition;
                    } else {
                        const totalScrolledDown = currentPosition - scrollReferenceRef.current;
                        if (totalScrolledDown >= headerHeight) {
                            setIsVisible(false);
                        }
                    }

                    scrollPositionRef.current = currentPosition;
                    ticking = false;
                });

                ticking = true;
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => window.removeEventListener("scroll", handleScroll);
    }, [headerHeight]);

    const headerClass = isMobile ? "header_mobile" : "header_desktop";
    const navClass = isMobile ? "nav_mobile" : "nav_desktop";

    const headerTranslateY = isVisible ? 0 : -headerHeight;

    const headerStyle = { transform: `translateY(${headerTranslateY}px)` };

    const setMenu = () => dispatch(openMenuMobile(!menuIsOpen));

    return (
        <header className={headerClass} style={headerStyle} ref={headerRef}>
            <div className="content">
                <h1>
                    <Link className="link_home" to={`/${language}`}>
                        <span className="brand_name">
                            VanRa<span className="lst-letter">h</span>
                        </span>
                        <span className="separator">-</span>
                        <span className="tagline">
                            <span className="tagline_word">Original</span>
                            <span className="tagline_word">Manga</span>
                            <span className="tagline_word">Artist</span>
                        </span>
                    </Link>
                </h1>
            </div>

            <nav className={`${navClass} ${menuIsOpen ? 'nav_open' : ''}`}>
                <button className="btn_menu" onClick={setMenu}>
                    Menu
                </button>

                <i className="starBar starBar_top"></i>

                <ul className="nav_list">
                    <li><Link to={`/${language}`}>VanRah</Link></li>
                    <li><Link to={`/${language}/illustrations`}>Illustrations</Link></li>
                    <li><Link to={`/${language}/mangas`}>Mangas</Link></li>
                    <li><Link to={`/${language}/works`}>Other Works</Link></li>
                    <li><Link to={`/${language}/planning`}>Planning</Link></li>
                    <li><Link to={`/${language}/contact`}>Contact</Link></li>
                    <li><Link to={`/${language}/shop`}>Shop</Link></li>
                </ul>

                <i className="starBar starBar_bottom"></i>
            </nav>
        </header>
    )
}

export default Header;